import { DiscardConfirmModal } from "./DiscardConfirmModal"
import { InventoryItemModal } from "./InventoryItemModal"
import { InventoryModal } from "./InventoryModal"

export const INVENTORY_MODALS = {
  inventory: {
    component: InventoryModal
  },
  inventoryItem: {
    component: InventoryItemModal,
    params: {} as { instanceId: string }
  },
  inventoryDiscardConfirm: {
    component: DiscardConfirmModal,
    params: {} as { instanceId: string }
  }
} as const
